import type { JSX } from 'react'

export const CloseIcon = (): JSX.Element => (
  <use href='#closeIcon' height='100%' width='100%' />
)
